import { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Alert, Form } from 'react-bootstrap';
import { Camera } from 'lucide-react';
import AppContext from '../../../../context/AppContext';
import axios from 'axios';
import "../../../../assets/css/customer/customerdashboard/customerprofile/profilepage.css";

const MyProfile = () => {
  const { baseUrl, validateField, authToken } = useContext(AppContext);

  const [customerId] = useState(localStorage.getItem("customerId"));
  const [profilePic, setProfilePic] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [nameError, setNameError] = useState('');
  const [profileMsg, setProfileMsg] = useState('');

  const [profile, setProfile] = useState({
    name: '',
    email: '',
  });

  useEffect(() => {
    if (!customerId) return;

    axios.get(`${baseUrl}/customer/get`, {
      params: { customer_id: customerId },
      headers: { 'Authorization': `Bearer ${authToken}` }
    })
    .then(response => {
  const customer = response.data.data;
  setProfile({
    name: customer.cus_username || '',
    email: customer.cus_email || '',
  });
})
    .catch(() => {
      setProfileMsg('Failed to load profile data');
    });
  }, [customerId, baseUrl, authToken]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setProfilePic(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    setProfile(prev => ({ ...prev, name: e.target.value }));
    if (nameError) setNameError('');
  };

  const handleSave = () => {
    const err = validateField('name', profile.name);
    if (err) { setNameError(err); return; }

    const formData = new FormData();
    formData.append('customer_id', customerId);
    formData.append('name', profile.name);

    axios.post(`${baseUrl}/customer/update`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${authToken}`
      }
    })
    .then(response => {
  if (response.data.success) {
    setProfile(prev => ({ ...prev, name: response.data.customer.cus_username }));
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  }
})
    .catch(error => {
      setProfileMsg(error.response?.data?.message || 'Failed to update profile');
    });
  };

  const getInitials = (name) => {
    return name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : 'C';
  };

  return (
    <div className="cus-prf-wrapper">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={8} lg={6}>
            <Card className="cus-prf-card">
              <Card.Body>

                <div className="text-center mb-4">
                  <div className="cus-prf-pic-container">
                    {profilePic ? (
                      <img src={profilePic} alt="Profile" className="cus-prf-pic-image" />
                    ) : (
                      <div className="cus-prf-pic-placeholder">
                        {getInitials(profile.name)}
                      </div>
                    )}
                   
                  </div>
                  <h3 className="fw-bold mt-3">My Profile</h3>
                  <p className="text-muted">Manage your personal information</p>
                </div>

                {showAlert && (
                  <Alert variant="success" className="cus-prf-alert">
                    Profile updated successfully!
                  </Alert>
                )}

                {profileMsg && (
                  <Alert variant="danger" className="cus-prf-alert">
                    {profileMsg}
                  </Alert>
                )}

                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="fullName"
                      placeholder="Enter your full name"
                      value={profile.name}
                      onChange={handleInputChange}
                      className={nameError ? 'is-invalid' : ''}
                    />
                    {nameError && (
                      <Form.Control.Feedback type="invalid" className="d-block">
                        {nameError}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      value={profile.email}
                      disabled
                    />
                  </Form.Group>

                  <button type="button" className="w-100 cus-prf-btn" onClick={handleSave}>
                    Update Profile
                  </button>
                </Form>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MyProfile;